import { render } from "./TemplateTwo.vue?vue&type=template&id=4660d852"
import script from "./TemplateTwo.vue?vue&type=script&lang=js"
export * from "./TemplateTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__